module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1047-14aedad1bd2ea8323bf508f660a8752c.png";